import { Plus, Key } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AccessTokenRow } from './AccessTokenRow';
import { useFetchApiTokens } from '@/hooksApi';
import { SettingsBreadcrumb } from '@/components/SettingsBreadcrumb';
import { SettingsListLoading } from '@/components/SettingsListLoading';
import { toast } from '@/hooks/use-toast';
import { ROUTE } from '@/config';

const SettingsAccessTokens = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: tokenList, isLoading: isLoadingTokens } = useFetchApiTokens();

  const handleCreateToken = () => {
    navigate(ROUTE.SETTINGS_ACCESS_TOKENS_CREATE);
  };

  const handleCopy = (value: string, label: string) => {
    if (value) {
      navigator.clipboard.writeText(value);
      toast({ title: `${label} ${t('copied_to_clipboard')}` });
    }
  };

  const tokens = tokenList?.object.items ?? [];

  return (
    <div className='sd-scope sd-font flex flex-col'>
      <div className='p-6 space-y-6 max-w-3xl w-full mx-auto'>
        <SettingsBreadcrumb moduleName='access_tokens' moduleRoute={ROUTE.SETTINGS_ACCESS_TOKENS} />

        <div className='flex items-center justify-between'>
          <h1 className='text-xl font-semibold text-sd-foreground'>{t('access_tokens')}</h1>
          <button
            onClick={handleCreateToken}
            className='flex items-center gap-2 px-4 py-2.5 rounded-lg bg-sd-primary text-sd-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity'
          >
            <Plus className='h-4 w-4' />
            {t('new_token')}
          </button>
        </div>

        {/* Token List */}
        {isLoadingTokens ? (
          <SettingsListLoading />
        ) : tokens.length === 0 ? (
          <div className='rounded-2xl border border-sd-border bg-sd-card shadow-sm p-8 text-center'>
            <Key className='h-10 w-10 mx-auto text-sd-muted-foreground mb-3' />
            <p className='text-sm text-sd-muted-foreground'>{t('no_access_tokens_yet')}</p>
          </div>
        ) : (
          <div className='space-y-3'>
            {tokens.map((token) => (
              <AccessTokenRow key={token.key} token={token} onCopy={handleCopy} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsAccessTokens;
